import { useEffect, useState } from "react";

import Typography from "@/foundation/Typography/V2";

import {
  clsx,
  classNameGenerator,
  getTimeDifferenceFromNow,
  isDateInPast,
} from "@/utils";

import styles from "./TimeCounter.module.scss";

interface OfferCountdownProps {
  label?: string;
  endDate: string;
  className?: string;
  icon?: string
}

const OfferCountdown: React.FC<OfferCountdownProps> = ({
  label,
  endDate,
  className,
  icon
}) => {
  const cls = classNameGenerator(styles);

  const [isDateHasPassed, setIsDateHasPassed] = useState(false);

  const [countdown, setCountdown] = useState(null);

  useEffect(() => {
    setIsDateHasPassed(isDateInPast(endDate))
    setCountdown(getTimeDifferenceFromNow(endDate))
    const interval = setInterval(() => {
      const timeObject = getTimeDifferenceFromNow(endDate);
      setIsDateHasPassed(timeObject?.seconds < 0);
      setCountdown(timeObject);
    }, 1000);

    return () => clearInterval(interval);
  }, [endDate]);

  if (isDateHasPassed) {
    return <></>;
  }

  return (
    <div className={clsx(cls("offerCountdown"), className)}>
      <div className={cls("offerTextContainer")}>
        <div className={cls("timeContainer")}>
          <span className={cls("timer")}>{countdown?.days}</span>
          <Typography variant="paragraph4" className={cls("timeLabel")}>
            D
          </Typography>
        </div>
        <div className={cls("timeContainer")}>
          <span className={cls("timer")}>{countdown?.hours}</span>
          <Typography variant="paragraph4" className={cls("timeLabel")}>
            H
          </Typography>
        </div>
        <div className={cls("timeContainer")}>
          <span className={cls("timer")}>{countdown?.minutes}</span>
          <Typography variant="paragraph4" className={cls("timeLabel")}>
            M
          </Typography>
        </div>
        <div className={cls("timeContainer")}>
          <span className={cls("timer")}>{countdown?.seconds}</span>
          <Typography variant="paragraph4" className={cls("timeLabel")}>
            S
          </Typography>
        </div>
      </div>
    </div>
  );
};

export default OfferCountdown;
